module.exports = __webpack_public_path__ + "img/region_selva.215e13f2.svg";